<template>
    <v-container fluid>
        <div class="report">
            <div class="header">
                <div class="s-title">年度财务汇总</div>
                <a-row class="staticlist">
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">年目标毛利</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(yeardata.v0, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">年收入</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(yeardata.v1, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">年成本</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(yeardata.v2, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">年实际毛利</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(yeardata.v3, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">年净利润</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(yeardata.v7, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">年完成率</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ yeardata.vr }} % </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <div class="s-title">月度财务汇总</div>
                <a-row class="staticlist">
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">月目标毛利</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(monthdata.v0, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">月收入</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(monthdata.v1, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">月成本</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(monthdata.v2, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">月实际毛利</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(monthdata.v3, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">月净利润</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ $utils.formatMoney(monthdata.v7, 2, '') }} </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="card">
                            <div class="avatar">
                                <img src="@/assets/w-2.png" style="width: 60px; height: 60px;" />
                            </div>
                            <div class="mc">
                                <div class="ctitle">月完成率</div>
                                <div class="cnum">
                                    <LoadingOutlined v-if="loading" />
                                    <span v-else> {{ monthdata.vr }} % </span>
                                </div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <div class="list">
                <div class="s-title">月度财务报表明细</div>
                <a-tabs v-model:activeKey="tab" @change="getData">
                    <a-tab v-for="item in tabs" :key="item.value" :tab="item.text "></a-tab>
                </a-tabs>
                <a-table class="tb_report" size="small" :columns="columns" :data-source="list" :loading="loading"
                    :locale="{ emptyText: '暂无数据' }" style="width: 100%;" row-key="_id" :pagination="false">
                    <template #bodyCell="{ record, column }">
                        <template v-if="column.dataIndex === 'fv0'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(0, record)">
                                {{ record.fv0 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v0 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v0 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv0 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv1'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(1, record)">
                                {{ record.fv1 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v1 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v1 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv1 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv2'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(2, record)">
                                {{ record.fv2 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v2 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v2 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv2 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv3'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(3, record)">
                                {{ record.fv3 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v3 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v3 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv3 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv4'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(4, record)">
                                {{ record.fv4 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v4 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v4 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv4 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv5'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(5, record)">
                                {{ record.fv5 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v5 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v5 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv5 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv6'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(6, record)">
                                {{ record.fv6 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v6 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v6 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv6 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv7'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(7, record)">
                                {{ record.fv7 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v7 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v7 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv7 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv8'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(8, record)">
                                {{ record.fv8 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v8 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v8 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv8 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv9'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(9, record)">
                                {{ record.fv9 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v9 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v9 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv9 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv10'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(10, record)">
                                {{ record.fv10 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v10 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v10 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv10 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv11'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail(11, record)">
                                {{ record.fv11 }}
                            </a>
                            <span v-else :class="{
                                'success--text': (record.highlight && record.v11 > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.v11 < 0) || record.textClass === 'error--text'
                            }">{{ record.fv11 }}</span>
                        </template>
                        <template v-if="column.dataIndex === 'fv12'">
                            <a v-if="record.showdetail" href="javascript:;" @click="showdetail('t', record)">
                                {{ record.ftotal }}
                            </a>
                            <span v-else :class="{
                                'font-weight-bold': true,
                                'success--text': (record.highlight && record.total > 0) || record.textClass === 'success--text',
                                'error--text': (record.highlight && record.total < 0) || record.textClass === 'error--text'
                            }">{{ record.ftotal }}</span>
                        </template>
                    </template>
                </a-table>
            </div>
        </div>
        <a-drawer :visible="dmodal" title="管理费用明细" @close="() => dmodal = false" placement="right" width="30%">
            <a-table size="small" :columns="dcolumns" :data-source="dlist" :loading="feeloading"
                :locale="{ emptyText: '暂无数据' }" style="width: 100%;" :pagination="false">
                <template #bodyCell="{ record, column }">
                    <template v-if="column.dataIndex === 'operation'">
                        <a href="javascript:;" @click="showfeedetail(record)">查看</a>
                    </template>
                </template>
            </a-table>
        </a-drawer>
        <a-modal :visible="drmodal" title="关联审批单" @cancel="() => drmodal = false" :footer="null" :width="750">
            <a-table size="small" :columns="drcolumns" :data-source="drlist" :scroll="{ y: 600 }"
                :locale="{ emptyText: '暂无数据' }" style="width: 100%;" :pagination="false">
                <template #bodyCell="{ record, column }">
                    <template v-if="column.dataIndex === 'businessId'">
                        <p>{{ record.businessId }}</p>
                        <p>{{ record.title }}</p>
                    </template>
                    <template v-else-if="column.dataIndex === 'expenseInfo'">
                        <p v-html="record.expenseInfo.replace(/\n/g, '<br>')"></p>
                    </template>
                </template>
            </a-table>
        </a-modal>
    </v-container>
</template>

<script>
import _ from "underscore";
import { LoadingOutlined } from "@ant-design/icons-vue";
import { mapState } from "vuex";
export default {
    name: "Report",
    data() {
        return {
            tabs: [
                { value: "0", text: "项目汇总", },
                { value: "1", text: "众牧公司", },
                { value: "2", text: "双阳公司", },
            ],
            columns: [
                { title: "科目", dataIndex: "project", width: 100, align: "center", },
                { title: "一月", dataIndex: "fv0", width: 100, align: "center" },
                { title: "二月", dataIndex: "fv1", width: 100, align: "center" },
                { title: "三月", dataIndex: "fv2", width: 100, align: "center" },
                { title: "四月", dataIndex: "fv3", width: 100, align: "center" },
                { title: "五月", dataIndex: "fv4", width: 100, align: "center" },
                { title: "六月", dataIndex: "fv5", width: 100, align: "center", },
                { title: "七月", dataIndex: "fv6", width: 100, align: "center", },
                { title: "八月", dataIndex: "fv7", width: 100, align: "center" },
                { title: "九月", dataIndex: "fv8", width: 100, align: "center" },
                { title: "十月", dataIndex: "fv9", width: 100, align: "center", },
                { title: "十一月", dataIndex: "fv10", width: 100, align: "center", },
                { title: "十二月", dataIndex: "fv11", width: 100, align: "center", },
                { title: "合计", dataIndex: "ftotal", width: 120, align: "center", fixed: "right", }
            ],
            loading: false,
            list: [],
            yeardata: {
                v0: 6000000,
                v1: 0,
                v2: 0,
                v3: 0,
                v7: 0,
                vr: 0,
            },
            monthdata: {
                v0: 500000,
                v1: 0,
                v2: 0,
                v3: 0,
                v7: 0,
                vr: 0,
            },
            height: 600,
            dmodal: false,
            dlist: [],
            dmonth: '',
            dtotal: {
                label: "合计",
                value: "",
            },
            dcolumns: [
                { title: "项目", dataIndex: "label", width: 120, align: "center", },
                { title: "费用", dataIndex: "value", width: 120, align: "center" },
                { title: "关联审批", dataIndex: "operation", width: 120, align: "center" },
            ],
            drlist: [],
            drcolumns: [
                { title: "审批单", dataIndex: "businessId", width: 240 },
                { title: "事由", dataIndex: "expenseInfo", },
                { title: "金额", dataIndex: "fee", width: 120 },
            ],
            drmodal: false,
            feeloading: false,
            tab: "0",
        }
    },
    computed: {
        ...mapState(["role", "username"]),
        width() {
            return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
        },
    },
    components: {},
    mounted() {

    },
    activated() {
        //this.getData();
    },
    methods: {
        getData() {
            this.$toast.loading({ message: "" });
            this.$api.doAPI("/caiwu_report/list", { tab: this.tabs[this.tab].value }).then((res) => {
                this.tabs = res.data.tabs;
                if (this.tab === 0) {
                    this.yeardata = res.data.yeardata;
                    this.monthdata = res.data.monthdata;
                }
                this.list = res.data.list.map(n => {
                    return {
                        ...n,
                        highlight: n.project === '项目毛利' || n.project === '项目净利润',
                        textClass: n.project === '业务收入' ? 'success--text' : (n.project === '业务成本' || n.project === '资金成本') ? 'error--text' : '',
                        showdetail: n.project === '管理费用',
                        fv0: this.$utils.formatMoney(n.v0, 2, ''),
                        fv1: this.$utils.formatMoney(n.v1, 2, ''),
                        fv2: this.$utils.formatMoney(n.v2, 2, ''),
                        fv3: this.$utils.formatMoney(n.v3, 2, ''),
                        fv4: this.$utils.formatMoney(n.v4, 2, ''),
                        fv5: this.$utils.formatMoney(n.v5, 2, ''),
                        fv6: this.$utils.formatMoney(n.v6, 2, ''),
                        fv7: this.$utils.formatMoney(n.v7, 2, ''),
                        fv8: this.$utils.formatMoney(n.v8, 2, ''),
                        fv9: this.$utils.formatMoney(n.v9, 2, ''),
                        fv10: this.$utils.formatMoney(n.v10, 2, ''),
                        fv11: this.$utils.formatMoney(n.v11, 2, ''),
                        ftotal: this.$utils.formatMoney(n.total, 2, ''),
                    }
                });
                this.$toast.clear();
            });
        },
        showdetail(i, item) {
            if (item[`v${i}list`].length === 0) return;
            let total = this.$utils.d();
            this.dlist = item[`v${i}list`].map(n => {
                total = total.plus(n.value);
                return {
                    value: this.$utils.formatMoney(n.value, 2, ''),
                    label: n.label,
                };
            });
            this.dmonth = item[`v${i}m`];
            this.dtotal.value = this.$utils.formatMoney(total, 2, '');
            this.dmodal = true;
        },
        showfeedetail(item) {
            this.$toast.loading({ message: "" });
            this.$api.doAPI("/caiwu_report/feedetail", { month: this.dmonth, label: item.label, tab: this.tabs[this.tab].value }).then((res) => {
                this.$toast.clear();
                if (res.code === 0) {
                    this.drlist = res.data.result;
                    this.drmodal = true;
                } else {
                    this.$alert(res.msg);
                }
            }).catch((err) => {
                this.$toast.clear();
                console.error(err);
            });
        }
    },
};

</script>
<style lang="less" scoped>
.report {
    .s-title {
        font-size: 24px;
        padding: 0 0 10px 0;
    }

    .staticlist {
        background: #fff;
        margin-bottom: 10px;

        .card {
            display: flex;

            .mc {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin-left: 10px;

                .ctitle {
                    font-size: 20px;
                }

                .cnum {
                    font-size: 20px;
                    font-weight: bold;
                }
            }
        }
    }
}

p {
    margin: 0;
}
</style>
